<template>
    <div class="check-list-example">
        <div class="checklist-items">
            <div
                class="checklist-item"
                v-for="item in partIn.list_items"
                :key="item.id">
                <div class="check-list-question">
                    <b-form-checkbox
                        class="apprentice-checkbox answer-list-checkbox"
                        value="1"
                        unchecked-value="0">
                    </b-form-checkbox>
                    <design-2021-lesson-module-assignment-type-assignment-part-list-item-component
                        @list-item-updated="updateListItem"
                        :item-in="item">
                    </design-2021-lesson-module-assignment-type-assignment-part-list-item-component>
                </div>

                <b-button
                    class="btn-remove btn-remove-question"
                    v-b-tooltip.hover
                    variant="danger-icon-only"
                    title="Verwijderen"
                    :disabled="partIn.list_items.length === 1"
                    @click="deleteItem(item)">
                </b-button>
            </div>
        </div>

        <div class="new-list">
            <design-2021-lesson-module-assignment-type-assignment-part-list-question-component
                @list-item-added="addListItem"
                :part-in="partIn">
            </design-2021-lesson-module-assignment-type-assignment-part-list-question-component>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-lesson-module-assignment-type-assignment-part-checklist-component',
    props: {
        partIn: Object,
    },

    data() {
        return {
            questionTitle: [],
        };
    },

    methods: {
        showEditModal() {
            this.$bvModal.show(`edit-assignment-part-checklist-modal-${this.partIn.id}`);
        },

        deleteItem(item) {
            this.$emit('call-delete-item', item);
        },

        updateQuestionTitle(value, item) {
            this.$emit('call-update-item', value, item);
        },

        updateListItem(newItem) {
            let part = this.partIn;
            part.list_items = part.list_items.map((item) => {
                if (item.id === newItem.id) {
                    return newItem;
                }
                return item;
            });

            this.updatePart(part);
        },
        addListItem(newItem) {
            let part = this.partIn;
            part.list_items.push(newItem);

            this.$emit('part-updated', part);
        },
    },

    computed: {
        questionTitles() {
            this.questionTitle = [];
            for (const name of this.partIn.list_items) {
                this.questionTitle.push({ edit: false });
            }

            return this.questionTitle;
        },
    },
    created() {
        for (const name of this.partIn.list_items) {
            this.questionTitle.push({ edit: false });
        }
    },
};
</script>

<style scoped lang="scss">
.checklist-item {
    display: flex;
    flex: 1 0 100%;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

    .check-list-question {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: calc(100% - 48px);

        .assignment-default-list-label {
            width: 100%;

            &.editing + .answer-list-checkbox {
                display: none;
            }
        }
    }

    .btn-remove-question {
        align-self: center;
        font-size: 1.3125rem;
    }
}

.answer-list-checkbox ::v-deep {
    input[type='checkbox'] + .custom-control-label:before {
        top: calc(50% - 8px);
        margin-right: 0;
    }

    > label {
        padding-bottom: 5px;
    }
}

.checklist-items {
    margin-bottom: $grid-gutter-width;
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .checklist-items {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: map-get($grid-gutter-spacing, 'fifteen') $grid-gutter-width;

        .checklist-item {
            flex: 0 0 calc(50% - 42px);
            margin: 0;
        }
    }

    .new-list {
        .new-question {
            width: calc(50% - 42px);
        }
    }
}
</style>
